export const validator = (value) => value != null;

export const emailValidator = (value) =>
  value != null && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);

export const passwordValidator = (value) => value != null && value.length >= 6;

export const repeatPasswordValidator = (value, password) =>
  value != null && password != null && value === password;

export const titleValidator = (value) => {
  return value != null && value.trim() !== '';
};
